export type JournalEntryScope =
    | {
          kind: "entity";
          entityId: number;
      }
    | {
          kind: "consolidationGroup";
          consolidationGroupId: string;
      };

export function isJournalEntryScopeEqual(
    left: JournalEntryScope,
    right: JournalEntryScope,
): boolean {
    switch (left.kind) {
        case "entity":
            return right.kind === "entity" && left.entityId === right.entityId;
        case "consolidationGroup":
            return (
                right.kind === "consolidationGroup" &&
                left.consolidationGroupId === right.consolidationGroupId
            );
        default: {
            const exhaustiveScope: never = left;
            return exhaustiveScope;
        }
    }
}
